<!-- 版本维护 -->
<template>
    <div class="content">
        <Button
            class="theme-bc mb24"
            icon="md-add-circle"
            type="warning"
            @click="gomodal"
            >新增版本</Button
        >
        <Table :columns="columnsTable" :data="dataTable" border>
            <template slot-scope="{ row }" slot="operate">
                <div class="flex-sa">
                    <Button
                        type="primary"
                        ghost
                        label="small"
                        @click="gomodal(row)"
                        >编辑</Button
                    >
                    <Button type="error" ghost label="small" @click="goDel(row)"
                        >删除</Button
                    >
                </div>
            </template>
        </Table>
        <div class="page-container">
            <Page
                :current="storePrams.page"
                :page-size="storePrams.limit"
                :total="total"
                show-total
                @on-change="pageChange"
            />
        </div>
        <!-- 新增/编辑 -->
        <Modal
            v-model="modals"
            :title="modalTitle"
            width="600"
            :mask-closable="false"
        >
            <div>
                <Form
                    :model="formItem"
                    label-position="right"
                    :label-width="100"
                >
                    <FormItem label="版本标题：">
                        <Input
                            class="w300"
                            type="text"
                            v-model="formItem.title"
                            placeholder="请输入版本标题"
                        ></Input>
                    </FormItem>
                    <FormItem label="版本详情：">
                        <Input
                            class="w300"
                            type="textarea"
                            v-model="formItem.reason"
                            placeholder="请输入版本详情"
                        ></Input>
                    </FormItem>
                    <FormItem label="版本号：">
                        <Input
                            class="w300"
                            type="text"
                            v-model="formItem.version"
                            placeholder="请输入版本号"
                        ></Input>
                    </FormItem>
                    <FormItem label="更新日期：">
                        <DatePicker
                            class="w300"
                            :value="formItem.v_time"
                            type="datetime"
                            placeholder="请选择更新日期"
                            @on-change="changeDate"
                        ></DatePicker>
                    </FormItem>
                    <FormItem label="上传图片">
                        <div class="form-div">
                            <Upload
                                class="form-upload"
                                ref="upload"
                                :show-upload-list="false"
                                :format="['jpg', 'jpeg', 'png', 'gif']"
                                :max-size="2048"
                                :on-progress="handleProgress"
                                :on-format-error="handleFormatError"
                                :on-success="imgSuccess"
                                :headers="headers"
                                :action="uploadImg"
                            >
                                <Icon type="ios-add" size="40" color="#ccc" />
                            </Upload>
                            <div class="dis-flex">
                                <div
                                    v-for="(item, index) in show_imgs"
                                    :key="index"
                                    class="form-img"
                                >
                                    <Icon
                                        class="form-icon"
                                        size="24"
                                        type="ios-close-circle-outline"
                                        color="#f00"
                                        @click="delImg(index)"
                                    />
                                    <img class="wh100" :src="item" />
                                </div>
                            </div>
                        </div>
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button @click="cancelModal">取消</Button>
                <Button class="theme-bc" type="warning" @click="submitModal"
                    >确认</Button
                >
            </div>
        </Modal>
    </div>
</template>

<script>
import { version_index, log_version_save, version_delete } from "@/api/index";
import config from "@/config/index";
import { getCookies } from "@/utils/helper";
export default {
    data() {
        return {
            uploadImg: config.apiUrl + "/plat/other/upload",
            headers: { "hlzw-plat-suyuan-token": getCookies("platToken") },
            storePrams: {
                page: 1,
                limit: 30,
            },
            total: 0,
            columnsTable: [
                { type: "index", width: 60, align: "center" },
                { title: "标题", key: "title", align: "center" },
                { title: "版本日期", key: "v_time", align: "center" },
                { title: "创建日期", key: "created_at", align: "center" },
                {
                    title: "操作",
                    slot: "operate",
                    align: "center",
                    width: "200px",
                },
            ],
            dataTable: [],
            modals: false,
            modalTitle: "",
            formItem: {
                title: "",
                reason: "",
                version: "",
                v_time: "",
                img: "",
                id: "",
            },
            show_imgs: [],
            imgs: [],
        };
    },
    mounted() {
        this.getList();
    },
    methods: {
        getList() {
            version_index(this.storePrams).then((res) => {
                this.dataTable = res.data.data;
                this.total = res.data.total;
            });
        },
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        gomodal(row) {
            if (row.id) {
                this.modalTitle = "编辑版本";
                this.formItem.title = row.title;
                this.formItem.reason = row.reason;
                this.formItem.version = row.version;
                this.formItem.v_time = row.v_time;
                this.formItem.img = row.img;
                this.formItem.id = row.id;
                this.show_imgs = row.show_imgs;
                this.imgs = this.formItem.img.split(",");
            } else {
                this.modalTitle = "新增版本";
                this.formItem.title = "";
                this.formItem.reason = "";
                this.formItem.version = "";
                this.formItem.v_time = "";
                this.formItem.img = "";
                this.formItem.id = "";
                this.show_imgs = [];
                this.imgs = [];
            }
            this.modals = true;
        },
        // 确定
        submitModal() {
            this.formItem.img = this.imgs.join(",");
            log_version_save(this.formItem)
                .then((res) => {
                    this.getList();
                    this.modals = false;
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        cancelModal() {
            this.modals = false;
        },
        goDel(row) {
            this.$Modal.confirm({
                title: "删除提示",
                content: "确认删除吗？",
                onOk: () => {
                    version_delete({ id: row.id })
                        .then((res) => {
                            this.getList();
                            this.$Message.success(res.msg);
                        })
                        .catch((res) => {
                            this.$Message.error(res.msg);
                        });
                },
                onCancel: () => {},
            });
        },
        changeDate(e) {
            if (e) {
                this.formItem.v_time = e;
            } else {
                this.formItem.v_time = "";
            }
        },
        // 文件上传时
        handleProgress() {
            this.$Message.loading({
                content: "上传中...",
                duration: 0,
            });
        },
        // 文件上传类型错误
        handleFormatError() {
            this.$Message.destroy();
            this.$Message.warning("暂不支持上传此格式");
        },
        imgSuccess(e) {
            this.show_imgs.push(e.data.path);
            this.imgs.push(e.data.url);
            this.$Message.destroy();
            this.$Message.success(e.msg);
        },
        delImg(index) {
            this.imgs.splice(index, 1);
            this.show_imgs.splice(index, 1);
        },
    },
};
</script>

<style scoped>
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.header {
    padding: 24px 24px 0 24px;
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    background-color: #fff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.flex-sa {
    display: flex;
    align-items: center;
    justify-content: space-around;
}
.form-upload {
    margin-right: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 80px;
    width: 80px;
    min-height: 80px;
    height: 80px;
    border-radius: 4px;
    border: 1px dashed #ccc;
    cursor: pointer;
}
.dis-flex {
    display: flex;
    flex-wrap: wrap;
}
.form-img {
    margin: 0 24px 24px 0;
    width: 80px;
    height: 80px;
    position: relative;
    border: 1px dashed #ccc;
    border-radius: 4px;
}
.form-icon {
    position: absolute;
    top: -10px;
    right: -10px;
    cursor: pointer;
}
.wh100 {
    width: 100%;
    height: 100%;
}
.form-div {
    display: flex;
}
.flex-sb {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.icon-sort {
    width: 18px;
    height: 18px;
    cursor: pointer;
}
.page-container {
    margin-top: 24px;
    text-align: right;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
</style>